export default {"src":"/_next/static/media/icon_12.3a828eec.svg","height":34,"width":34};